import { Amplify, Auth, Hub } from "aws-amplify";
import QRCodeSVG from "qrcode.react";
import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import Marquee from "react-css-marquee";
import { RiCloseLine, RiUserUnfollowLine } from "react-icons/ri";
import { useLocation, useNavigate } from "react-router-dom";
import {
  invokeLambdaWithRetry,
  isEmailChar,
  logAudit,
  setUserVault,
  validateEmail,
} from "services/Helper";
import CryptoJS from "crypto-js";
import config from "../../aws-exports";
import MeaBannerIcon from "../../newui/assets/images/login_mea_banner.svg";
import MeaIcon from "../../newui/assets/images/Mea-Logo 1.svg";
import MicrosoftIcon from "../../newui/assets/images/microsoft-icon.svg";
import "../assets/css/style.css";
import logo from "../assets/images/logo.png";
import "../assets/vendors/base/vendor.bundle.base.css";
import "../assets/vendors/ti-icons/css/themify-icons.css";
import CirclesLoader from "../layouts/CirclesLoader";
import { MdOutlineEmail } from "react-icons/md";
import { createUiLogger } from "../../logging/uiLogger";
const console = createUiLogger("meaplatform/classic/views/Start.js");




const queryString = window.location.search;
const queryParam = new URLSearchParams(queryString);
const errorMsg = queryParam.get("error_description");
const isDisabledSsoError = (message) =>
  ["User is not enabled", "User is disabled"].includes(
    message?.replace(/\+/g, " ").replace(/\.$/, "")
  );

var ampCfg = {
  Auth: {
    region: config.aws_project_region,
    identityPoolId: config.aws_cognito_identity_pool_id,
    userPoolId: config.aws_user_pools_id,
    userPoolWebClientId: config.aws_user_pools_web_client_id,
    oauth: {
      domain:
        import.meta.env.VITE_MEA_OKTA_DOMAIN === undefined
          ? import.meta.env.VITE_MEA_SSO_DOMAIN
          : import.meta.env.VITE_MEA_OKTA_DOMAIN,
      scope: [
        "email",
        "phone",
        "openid",
        "aws.cognito.signin.user.admin",
        "profile",
      ],
      redirectSignIn: window.location.origin,
      redirectSignOut: window.location.origin,
      responseType: "code",
    },
  },
  Storage: {
    AWSS3: {
      bucket: config.aws_user_files_s3_bucket, // (required) -  Amazon S3 bucket name
      region: config.aws_project_region, // (optional) -  Amazon service region
    },
  },
};
Amplify.configure(ampCfg);

function Start(props) {
  //console.log(props);

  const location = useLocation();
  let [email, setEmail] = useState("");
  let [password, setPassword] = useState("");
  let [showPassword, setShowPassword] = useState(false);
  let [authType, setAuthType] = useState("mea");
  let [showModal, setShowModal] = useState(false);
  let [showModalMsg, setShowModalMsg] = useState("");
  const [token, setToken] = useState(null);
  const [disableUpload, setDisableUpload] = React.useState(false); // by default disableUpload is set to true, only when set to true users will not be able to upload file
  const navigate = useNavigate();
  let [showQRCode, setShowQRCode] = useState(false);
  let [qrCode, setQRCode] = useState("");
  let [username, setUsername] = useState("");
  let [showTotpCode, setShowTotpCode] = useState(false);
  let [totpCode, setTotpCode] = useState("");
  let [challengeName, setChallengeName] = useState("");
  let [userObj, setUserObj] = useState();
  const [showUsageInstruction, setShowUsageInstruction] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [isFedDirect, setIsFedDirect] = useState(true);
  const [federatedButtonLabel, setFederatedButtonLabel] = useState("");
  const [showMicrosftBtn, setShowMicrosftBtn] = useState(false);
  const [showRegisterAuth, setShowRegisterAuth] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [enableSupportBtn,setEnableSupportBtn]=useState(false);
  const [isMeaSupportLogin, setIsMeaSupportLogin] = useState(
    location?.pathname?.includes("/login/measupport") ||
      location?.state?.meaUser === true
  );
  const logoLongPressTimerRef = useRef(null);
  const [modalContent, setModalContent] = useState({
    show: false,
    title: "",
    body: "",
    primaryAction: {},
    secondaryAction: {},
  });
  var counter = 0;

  function getToken() {
    return Auth.currentSession()
      .then((session) => session)
      .catch((err) => console.error(err));
  }

  var pendingUser = props.pendingUser;
  const { switchUI } = props;

  useEffect(() => {
    if (errorMsg) {
      setShowModal(true);
      setShowModalMsg(
        isDisabledSsoError(errorMsg)
          ? "Thank you for registering. Your account is awaiting approval. We’ll email you as soon as your access is approved."
          : errorMsg
      );
    }
    Hub.listen("auth", ({ payload: { event, data } }) => {
      switch (event) {
        case "signIn":
        case "cognitoHostedUI":
          setToken("grating...");
          getToken().then((userToken) => setToken(userToken.idToken.jwtToken));
          break;
        case "signOut":
          setToken(null);
          break;
        case "signIn_failure":
        case "cognitoHostedUI_failure":
          if (
            event === "cognitoHostedUI_failure" &&
            isDisabledSsoError(data.message)
          ) {
            setShowModal(true);
            setShowModalMsg(
              "Thank you for registering. Your account is awaiting approval. We’ll email you as soon as your access is approved."
            );
          } else if (data.message === "User+is+not+enabled") {
            setShowModal(true);
            setShowModalMsg(
              <>
                <p>Your User ID is pending approval</p>
                <p>Please contact mea support for approving your userid</p>
              </>
            );
          } else if (
            data.message ===
            "User+is+not+assigned+to+the+client+application.%3B+error%3Daccess_denied"
          ) {
            setShowModal(true);
            setShowModalMsg(
              <>
                <p>Your User ID is not granted access to mea platform</p>
                <p>
                  please contact your IT support for granting access to mea
                  platform
                </p>
              </>
            );
          }
          console.debug("Sign in failure", data);
          break;
        default:
      }
    });
    checkUploadStatus();
    loadAuthType();
    loadUsageInstruction();
    changeFedeartedButtonLabel();
  }, []);

  useEffect(() => {
    if (pendingUser === true) {
      setShowModal(true);
      setShowModalMsg(
        <>
          <p>Your User ID is pending approval</p>
          <p>Please contact mea support for approving your userid</p>
        </>
      );
    }
  }, [pendingUser]);

  useEffect(() => {
    if (import.meta.env.VITE_ENABLE_MICROSOFT === "true") {
      setShowMicrosftBtn(true);
    }
  }, [showMicrosftBtn]);

  async function getConfigValue(configName) {
    try {
      const body = {
        target: "getConfigValue",
        configName: configName,
      };
      const init = {
        body: body,
      };
      const data = await invokeLambdaWithRetry("instanceHandler", init);
      return data.response;
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  useEffect(() => {
    (async function init() {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const inviteId = urlParams.get("inviteid");
        if (inviteId !== null) {
          await getAcceptInvite(inviteId);
        }
      } catch (error) {
        console.error("Error processing invite:", error);
      }
    })();
  }, []);

  const getAcceptInvite = async (userSub) => {
    setLoading(true);
    try {
      const body = {
        target: "acceptinvite",
        user_sub: userSub,
      };
      const init = {
        body: body,
      };
      const data = await invokeLambdaWithRetry("instanceHandler", init);
      return { status: data.statusCode === 200, result: data };
    } catch (err) {
      console.error("err: ", err);
      return { status: false, error: err };
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
  if (location?.pathname?.includes("/login/measupport")) {
    setIsMeaSupportLogin(true);
        navigate("/login", {
      replace: true,
      state: { meaUser: true }
    });
    return;
  }

}, [location.pathname, navigate]);

  useEffect(() => {
    if (location.state?.meaUser) {
      setIsMeaSupportLogin(true);
      navigate(location.pathname, { replace: true, state: null });
    }
  }, [location.pathname, location.state, navigate]);

  useEffect(() => {
    return () => {
      if (logoLongPressTimerRef.current) {
        clearTimeout(logoLongPressTimerRef.current);
      }
    };
  }, []);

  const clearLogoLongPress = () => {
    if (logoLongPressTimerRef.current) {
      clearTimeout(logoLongPressTimerRef.current);
      logoLongPressTimerRef.current = null;
    }
  };

  const startLogoLongPress = () => {
    clearLogoLongPress();
    logoLongPressTimerRef.current = setTimeout(() => {
      logoLongPressTimerRef.current = null;
      navigate("/login/measupport");
    }, 2000);
  };

  var authTypeVal = undefined;
  async function loadAuthType() {
    if (authTypeVal === undefined) {
      authTypeVal = await getConfigValue("auth_type");
    }
    setAuthType(authTypeVal);
    if (authTypeVal === "client") {
      if (location.search?.toLowerCase().startsWith("?fed")) {
        try {
          await Auth.currentAuthenticatedUser({
            bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
          });
        } catch {
          localStorage.setItem("navigator", location.pathname);
          setIsFedDirect(true);
          handleFedLogin();
        }
      } else {
        setIsFedDirect(false);
      }
    } else {
      setIsFedDirect(false);
    }
    return authTypeVal;
  }

  var showUsageInstructionVal = undefined;
  async function loadUsageInstruction() {
    if (authTypeVal === undefined) {
      showUsageInstructionVal = await getConfigValue("ShowUsageInstruction");
    }
    setShowUsageInstruction(showUsageInstructionVal);
    return showUsageInstructionVal;
  }

  var federatedButtonLabelVal = undefined;
  async function changeFedeartedButtonLabel() {
    if (federatedButtonLabelVal === undefined) {
      federatedButtonLabelVal = await getConfigValue("FederatedButtonLabel");
    }
    setFederatedButtonLabel(federatedButtonLabelVal);
    return federatedButtonLabelVal;
  }

  var disableUploadVal = undefined;
  var disableUploadValTs;
  function isCacheValid(cacheValTs) {
    if (cacheValTs === undefined) {
      return false;
    }
    const now = new Date();
    const msBetweenDates = Math.abs(cacheValTs.getTime() - now.getTime());
    const secBetweenDates = msBetweenDates / 1000;
    if (secBetweenDates > 300) {
      return false;
    }
    return true;
  }

  async function checkUploadStatus() {
    if (
      disableUploadVal === undefined ||
      isCacheValid(disableUploadValTs) === false
    ) {
      disableUploadVal = await getConfigValue("DisableUpload");
      disableUploadValTs = new Date();
    }
    setDisableUpload(disableUploadVal === "true");
    return disableUploadVal === "true";
  }

  let handleFedLogin = async function (event) {
    if (event !== undefined) {
      event.preventDefault();
    }
    if (import.meta.env.VITE_MEA_SSO_DOMAIN !== undefined) {
      if (import.meta.env.VITE_MEA_SSO_TYPE === "cognito") {
        Auth.federatedSignIn({ provider: "ExtCognito" })
          .then(() => {})
          .catch((e) => {
            console.debug(e);
          });
      } else if (import.meta.env.VITE_MEA_SSO_TYPE === "googleworkspace") {
        Auth.federatedSignIn({ provider: "GoogleWorkspace" })
          .then(() => {})
          .catch((e) => {
            console.debug(e);
          });
      } else {
        Auth.federatedSignIn({ provider: "AzureAD" })
          .then(() => {})
          .catch((e) => {
            console.debug(e);
          });
      }
    } else {
      Auth.federatedSignIn({ provider: "Okta" })
        .then(() => {})
        .catch((e) => {
          console.debug(e);
        });
    }
  };

  async function loginRetry(fn, event, delay) {
    try {
      if (counter < 5) {
        counter += 1;
        await delayPromise(delay);
        var loginUser = await fn(event);
        return loginUser;
      }
    } catch (err) {
      console.error(err);
    }
    setShowModalMsg(
      <>
        <p>User is not verified or User is not commissioned for use</p>
        <p>Contact mea system admin</p>
      </>
    );
  }

  async function delayPromise(delay) {
    return new Promise((resolve) => setTimeout(resolve, delay));
  }

  const validateResolveUser = async (email, password) => {
    try {
      const body = {
        target: "resolve-user-vault-issue",
        UserId: email,
        password: password,
      };
      const init = {
        body: body,
      };
      const data = await invokeLambdaWithRetry("instanceHandler", init);
      return data;
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  async function getUserVault(email) {
    try {
      const body = {
        target: "getUserVault",
        UserId: email,
        headerFields: ["lastAccessedOn"]
      };
      const init = {
        body: body,
      };
      const result = await invokeLambdaWithRetry("instanceHandler", init);
      let userLastAccessed =
        result?.response?.data?.getUserVault?.lastAccessedOn;
      await localStorage.setItem("lastAccessed", userLastAccessed);
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  let handleLogin = async function (event) {
    event.preventDefault();
    if (email.trim().length === 0) return;
    if (password.trim().length === 0) return;
    if (validateEmail(email) !== true) return;
    setLoading(true);
    var user;
    try {
      localStorage.setItem("transitions", "off");
      if (authType === "mea") {
        //attempt signout of all devices
        await Auth.signOut({ global: true });
      }
      await getUserVault(email);
      const prepareUserVaultResp = await prepareUserVault(email, password);
      if (prepareUserVaultResp?.response?.status === "disabled") {
        setShowModal(true);
        setShowModalMsg(
          <>
            <p>Your registration is pending approval</p>
            <p>
              You will receive an email once approved, this may take up to 1
              hour
            </p>
          </>
        );
        setLoading(false);
        return;
      }
      if (
        prepareUserVaultResp?.response?.status === "fail"
      ) {
        setShowModal(true);
        setShowModalMsg("Login failed. The username or password entered is incorrect.");
        setLoading(false);
        return;
      }
      user = await Auth.signIn(email, password);
      var cognitoGroups =
        user?.signInUserSession?.accessToken?.payload["cognito:groups"][0];
      logAudit(
        undefined,
        undefined,
        "User",
        "Login",
        "UI",
        undefined,
        undefined
      ).then((data) => {});
      localStorage.removeItem("transitions");
      setUserObj(user);
      setChallengeName(user.challengeName);
      if (user.challengeName === "MFA_SETUP") {
        Auth.setupTOTP(user).then(async (code) => {
          setShowQRCode(true);
          setQRCode(code);
          setUsername(user.username);
          localStorage.setItem("mfaState", "MFA_SETUP");
        });
      } else if (user.challengeName === "SOFTWARE_TOKEN_MFA") {
        setShowTotpCode(true);
        localStorage.setItem("mfaState", "SOFTWARE_TOKEN_MFA");
      } else {
        if (import.meta.env.VITE_MFANAME !== undefined) {
          setChallengeName("MFA_SETUP");
          Auth.setupTOTP(user).then(async (code) => {
            setShowQRCode(true);
            setQRCode(code);
            setUsername(user.username);
            localStorage.setItem("mfaState", "MFA_SETUP");
          });
        }
        await setUserVault(
          password,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          cognitoGroups
        );
      }
      setLoading(false); // Login successful, stop the loader animation
    } catch (err) {
      if (err.message === "User is disabled.") {
        setShowModal(true);
        setShowModalMsg(
          <>
            <p>Your registration is pending approval</p>
            <p>
              You will receive an email once approved, this may take up to 1
              hour
            </p>
          </>
        );
      } else {
        if (
          err.message ===
          "PreAuthentication invocation failed due to error Socket timeout while invoking Lambda function."
        ) {
          await loginRetry(handleLogin, event, 5000);
        } else {
          let resolverUser = await validateResolveUser(email, password);
          if (resolverUser.response === false) {
            if (
              err.message === "Incorrect username or password." ||
              err.message === "User does not exist." ||
              err.code === "UserNotFoundException" ||
              err.code === "NotAuthorizedException"
            ) {
              setShowModalMsg(
                "Login failed. The username or password entered is incorrect."
              );
            } else {
              setShowModalMsg(err.message);
            }
            setShowModal(true);
            setLoading(false);
            return;
          }
          if (resolverUser.response === true) {
            await handleLogin(event);
          }
        }
      }

      console.error(err);
      setLoading(false); // Login failed, stop the loader animation
    }
  };

  let onCompleteTotp = async function (event) {
    event.preventDefault();
    try {
      if (challengeName === "MFA_SETUP") {
        localStorage.setItem("mfasetupready", "true");
        await Auth.verifyTotpToken(userObj, totpCode);
        Auth.setPreferredMFA(userObj, "TOTP");
        await setUserVault(password);
      } else if (challengeName === "SOFTWARE_TOKEN_MFA") {
        const loggedUser = await Auth.confirmSignIn(
          userObj, // Return object from Auth.signIn()
          totpCode, // Confirmation code
          challengeName // MFA Type e.g. SMS_MFA, SOFTWARE_TOKEN_MFA
        );
        setUserObj(loggedUser);
        var uInfo = loggedUser.signInUserSession.idToken.payload;
        await setUserVault(
          password,
          uInfo.given_name,
          uInfo.family_name,
          uInfo.phone_number,
          uInfo["custom:company"],
          uInfo["custom:country"],
          uInfo["cognito:groups"].join(","),
          uInfo.sub
        );
      }
      localStorage.removeItem("mfaState");
    } catch (err) {
      if (err.message === "User is disabled.") {
        setShowModalMsg(
          <>
            <p>Your registration is pending approval</p>
            <p>
              You will receive an email once approved, this may take up to 1
              hour
            </p>
          </>
        );
      } else if (err.message === "Code mismatch") {
        localStorage.removeItem("mfasetupready");
        setShowModalMsg(err.message);
      } else {
        setShowModalMsg(err.message);
      }
      setShowModal(true);
      console.error(err);
    }
  };

  async function prepareUserVault() {
    try {
      const body = {
        target: "prepareUserVault",
        UserId: email,
        passcode: password,
      };
      const init = {
        body: body,
      };
      return await invokeLambdaWithRetry("instanceHandler", init);
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  async function notifyUserResetAuthentication() {
    setLoading(true);
    try {
      if (email?.length <= 0) {
        setShowModal(true);
        setShowModalMsg("Please enter email address.");
        return;
      }
      var body = {
        email: email,
        target: "resetUserAuthenticator",
      };

      const init = {
        body: body,
      };
      await invokeLambdaWithRetry("instanceHandler", init);
    } catch (err) {
      console.error("err: ", err);
      setShowModalMsg(err?.message);
      setShowModal(true);
      setModalContent({
        show: false,
        title: "",
        body: "",
        primaryAction: {},
        secondaryAction: {},
      });
    } finally {
      setLoading(false);
    }
  }

  async function onResetAuthenticator() {
    setLoading(true);
    try {
      setModalContent({
        show: true,
        title: (
          <>
            A support request will be generated for the mea support team to
            reset your authenticator.
            <br />
            Would you like to proceed?
          </>
        ),
        primaryAction: {
          text: "Yes",
          onClick: async () => {
            await notifyUserResetAuthentication();
            setModalContent({
              show: true,
              title: (
                <>
                  Your request to reset the authenticator has been successfully
                  recorded.
                  <br />
                  You will receive a notification on your registered email once
                  the request has been processed.
                </>
              ),
              body: "",
              primaryAction: {
                text: "Ok",
                onClick: () => {
                  setModalContent({
                    show: false,
                    title: "",
                    body: "",
                    primaryAction: {},
                    secondaryAction: {},
                  });
                  redirectToLogin();
                },
              },
              secondaryAction: null,
            });
          },
        },
        secondaryAction: {
          text: "No",
          onClick: () =>
            setModalContent({
              show: false,
              title: "",
              body: "",
              primaryAction: {},
              secondaryAction: {},
            }),
        },
      });
    } catch (err) {
      console.error(err);
      return false;
    } finally {
      setLoading(false);
    }
  }

  const allowEmailChars = (e) => {
    if (isEmailChar(e.key) === false) {
      e.stopPropagation();
      e.preventDefault();
    }
  };

  useEffect(() => {
    console.debug("[Start] mounted");
  }, []);

  const redirectToLogin = () => {
    localStorage.removeItem("logout");
    window.location.href = "/login";
  };

  const redirectToRegister = () => {
    let path = `/register`;
    navigate(path);
  };

  const redirectToPwdReset = () => {
    let path = `/pwdreset`;
    navigate(path);
  };

  

  const validateUser = async (email) => {
    setLoading(true);
    try {
      console.debug("[Start] validateUser start", { email });
      localStorage.setItem("msUser", email);
      const body = {
        target: "fetchUserVault",
        UserId: email,
        microsoft: true,
      };
      const init = {
        body: body,
      };
      const data = await invokeLambdaWithRetry("instanceHandler", init);
      const response = data?.response ?? {};
      const { user_sub, Active, groups } = response;
      console.info("[Start] validateUser response", {
        statusCode: data?.statusCode,
        user_sub,
        Active,
        groups,
        hasResponse: Object.keys(response).length > 0,
      });
      if (
        (user_sub === "inactive" &&
          (Active === 0 || groups === "MEA_PENDINGUSERS")) ||
        (user_sub === null && (Active === 1 || groups !== "MEA_PENDINGUSERS")) ||
        user_sub?.startsWith("invite-")
      ) {
        let path = `/microsoftauth`;
        navigate(path);
      } else if (user_sub && Active !== 1) {
        let path = `/microsoftauth`;
        navigate(path);
      } else if (
        user_sub &&
        Active === 1 &&
        groups !== "MEA_PENDINGUSERS"
      ) {
        Auth.federatedSignIn({ customProvider: "AzureADOpen" })
          .then(() => {})
          .catch((e) => {
            console.debug(e);
          });
      } else if (Object.keys(response).length === 0) {
        let path = `/microsoftauth`;
        navigate(path);
      }
      return { status: data.statusCode === 200, result: data };
    } catch (err) {
      console.error("err: ", err);
      return { status: false, error: err };
    } finally {
      console.info("[Start] validateUser end");
      setLoading(false);
    }
  };

  const redirectToMicrosoftAuth = async () => {
    let checkMsUser = localStorage.getItem("msUser");
    const urlParams = new URLSearchParams(window.location.search);
    const inviteId = urlParams.get("inviteid");
    const normalizedMsUser =
      checkMsUser && checkMsUser !== "null" && checkMsUser !== "undefined"
        ? checkMsUser
        : "";
    console.debug("[Start] redirectToMicrosoftAuth", {
      inviteId,
      checkMsUser,
      normalizedMsUser,
    });
    if (inviteId !== null) {
      console.info("[Start] redirectToMicrosoftAuth inviteId detected");
      Auth.federatedSignIn({ provider: "AzureADOpen" })
        .then(() => {})
        .catch((e) => {
          console.debug(e);
        });
    } else if (normalizedMsUser) {
      const result = await validateUser(normalizedMsUser);
      console.debug("[Start] validateUser result", { status: result?.status });
      if (!result?.status) {
        let path = `/microsoftauth`;
        console.error("[Start] navigate to /microsoftauth (validate failed)");
        navigate(path);
      }
    } else {
      let path = `/microsoftauth`;
      console.debug("[Start] navigate to /microsoftauth (no msUser)");
      navigate(path);
    }
  };

  const shouldShowMicrosoftButton =
    showMicrosftBtn === true && !isMeaSupportLogin;
  const shouldShowFederatedButton = !isMeaSupportLogin;

  return (
    <>
      <div className="container-scroller">
        {disableUpload && (
          <Marquee
            cssNamespace="horizontal"
            text="our AI is currently training itself on advanced insurance data and is unavailable for use. uploading new submissions is paused now, please try again later."
          />
        )}
        {(showUsageInstruction === "true" || showUsageInstruction) && (
          <div className="usage-tourtext">
            <h4>how to use mea ingest module</h4>
            <ul className="pl-3 mb-1">
              <li>create an account and login</li>
              <li>upload submission documents for data extraction</li>
              <li>view extracted data on mea platform</li>
            </ul>
            <ul className="mb-1">
              <li>
                if you need help, please Click <b>Turn Tour On</b> in the
                submission screen for a step by step walk through or contact us
                on
                <a href="mailto:support@meaplatform.com">
                  support@meaplatform.com
                </a>
              </li>
            </ul>
          </div>
        )}

        <div className="authlayout-container p-3">
          <div className="h-100 authform-container flex">
            <div className="meaicon-banner p-2 flex-center">
              <div className="w-100">
                <img
                  src={MeaBannerIcon}
                  alt="MeaBannerIcon"
                  className="w-100"
                />
              </div>
            </div>

            <div className="flex authlogo-formcontainer">
              <div className="w-55 flex-colcenter">
                <div>
                  <div className="flex-center mb-3">
                    <div className="auth-mealogo-texticon">
                      <img src={logo} alt="MeaIconText" className="w-100" />
                    </div>
                  </div>
                  <div className="w-100">
                    <div className="flex-center">
                      <h1 className="authform-measlogan-text">
                        make your life
                      </h1>
                    </div>
                    <div className="flex-center">
                      <h1 className="authform-measlogan-text">easier</h1>
                    </div>
                  </div>
                </div>
                <p className="authform-limitedyear">
                  mea platform limited {new Date().getFullYear()}.
                </p>
              </div>
              <div className="authform-layoutcontainer flex-colcenter">
                <div className="authform-fieldcontainer">
                  <div className="mb-2 authform-mealogo-container">
                    <img
                      src={MeaIcon}
                      alt="MEA-ICON"
                      className="authform-mealogoicon"
                      onMouseDown={startLogoLongPress}
                      onMouseUp={clearLogoLongPress}
                      onMouseLeave={clearLogoLongPress}
                      onTouchStart={startLogoLongPress}
                      onTouchEnd={clearLogoLongPress}
                      onTouchCancel={clearLogoLongPress}
                    />
                  </div>
                  <h2 className="fw-bold text-center">
                    Welcome to mea! We’re glad you’re here.
                  </h2>
                  <h5 className="text-center authform-subtitle  mt-1">
                    Sign in to get started
                  </h5>

                  <div className="login-form">
                    {/* <h3>welcome</h3> */}

                    <form
                      autoComplete="off"
                      className="pt-3 login-validation-form"
                    >
                      {(isMeaSupportLogin ||
                      (isFedDirect === false && showMicrosftBtn === false && authType !== "client") ||
                      showMicrosftBtn === true) && (
                        <div
                          className="form-group mb-0 formcontainer-input-textfield"
                          data-tour="step-1"
                        >
                          <label className="login-formlabel text-left">
                            Email address
                          </label>
                          <div className="input-group">
                            <input
                              type="email"
                              className="formcontainer-inputfield"
                              id="inputEmail"
                              autoComplete="off"
                              readOnly={showQRCode === true}
                              value={email}
                              onKeyDown={allowEmailChars}
                              onChange={(event) => {
                                setEmail(event.target.value);
                              }}
                            />
                          </div>

                          {showQRCode === false && showTotpCode === false && (
                            <>
                              <div
                                className="form-group mb-0 formcontainer-input-textfield position-relative"
                                data-tour="step-2"
                              >
                                <label className="login-formlabel text-left mt-2">
                                  Password
                                </label>
                                <div className="input-group mb-1">
                                  <input
                                    type={showPassword ? "text" : "password"}
                                    className="formcontainer-inputfield"
                                    id="inputPassword"
                                    autoComplete="off"
                                    value={password}
                                    onChange={(event) => {
                                      setPassword(event.target.value);
                                    }}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        e.preventDefault();
                                        handleLogin(e);
                                      }
                                    }}
                                  />
                                  {/* {password && ( */}
                                    <span className="show-pwd">
                                      <button
                                        className="btn p-0 auth-link text-black"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          setShowPassword(!showPassword);
                                        }}
                                        onMouseDown={(e) => e.preventDefault()}
                                      >
                                        {showPassword ? "hide" : "show"}
                                      </button>
                                    </span>
                                  {/* )} */}
                                </div>
                              </div>
                            </>
                          )}

                          {showQRCode === false && showTotpCode === false && (
                            <>
                              <div className="flex justify-content-end align-items-center font-Poppins login-signedin-container h-20px mt-3 ">
                                <div
                                  className="login-forget-password cursor-pointer"
                                  onClick={redirectToPwdReset}
                                >
                                  Forgot your password?
                                </div>
                              </div>

                              <div className="flex flex-col align-items-center">
                                <button
                                  type="button"
                                  className="formfields-button login-btn"
                                  disabled={
                                    email.trim().length === 0 ||
                                    password?.trim().length === 0
                                  }
                                  id="btnLogin"
                                  onClick={handleLogin}
                                >
                                  Log in
                                </button>
                                </div>
                                  <div className="flex-center loginform-seperatefields">
                                  <div className="form-line-border w-37"></div>
                                  <div className="pl-3 pr-3 fw-500 login-or-separator">
                                    OR
                                  </div>
                                  <div className="form-line-border w-37"></div>
                                </div>
                              <div className="flex flex-col align-items-center">
                                <button
                                  type="button"
                                  className="formfields-button cursor-pointer authenticate-btn"
                                  onClick={redirectToRegister}
                                >
                                  Sign up
                                </button>
                              </div>
                            </>
                          )}
                        </div>
                      )}
                      {shouldShowMicrosoftButton &&  (
                        <>
                          <div className="row login-microsoft">
                            <div className="col-12 d-flex justify-content-center mb-3 mt-2">
                              <button
                                type="button"
                                className="formfields-button flex-center text-transform form-icon-button cursor-pointer authenticate-btn"
                                id="btnMicrosoft"
                                onClick={() => {
                                  redirectToMicrosoftAuth();
                                }}
                              >
                                <span className="mr-3">
                                  <img
                                    src={MicrosoftIcon}
                                    alt="logo-microsoft"
                                  />
                                </span>
                                Sign in with Microsoft
                              </button>
                            </div>
                          </div>
                        </>
                      )}

                      {showQRCode === true && (
                        <>
                          <div className="form-group text-center mb-0">
                            <label htmlFor="exampleInputPassword">
                              TOTP - setup to get authentication code
                            </label>
                            <div>
                              <h5>setup instructions</h5>
                              <ul
                                className={`totp-steps mb-1 ${
                                  isExpanded ? "expanded" : ""
                                }`}
                              >
                                {isExpanded ? (
                                  <>
                                    <li>
                                      Download & Install the Microsoft/Google
                                      Authenticator app from Play Store for
                                      Android users and from App Store for iOS
                                      users.
                                    </li>
                                    <li>
                                      To scan the QR code, click on the "+" icon
                                      in the app and select the option "work or
                                      school account".
                                    </li>
                                    <li>
                                      Click on the "Scan a QR code" option and
                                      scan the QR code displayed on the
                                      platform.
                                    </li>
                                    <li>
                                      An AWSCognito account will be created.
                                    </li>
                                    <li>
                                      Click on the account to get an
                                      authentication code.
                                    </li>
                                    <li>
                                      Enter the authentication code in the
                                      platform and click on the submit button.
                                    </li>
                                  </>
                                ) : (
                                  <li>
                                    Download & Install the Microsoft
                                    Authenticator app from Play Store for
                                    Android users and from App Store for iOS
                                    users...
                                  </li>
                                )}
                              </ul>
                              <button
                                className="btn p-0 auth-link text-green"
                                onClick={(event) => {
                                  event.preventDefault();
                                  setIsExpanded(!isExpanded);
                                }}
                              >
                                {isExpanded ? "show less" : "show more"}
                              </button>
                            </div>
                            <div className="input-group d-flex justify-content-center">
                              <QRCodeSVG
                                size={230}
                                value={`otpauth://totp/AWSCognito:${username}?secret=${qrCode}&issuer=${import.meta.env.VITE_MFANAME}`}
                                includeMargin={true}
                              />
                            </div>
                          </div>
                        </>
                      )}

                      {(showQRCode === true || showTotpCode === true) && (
                        <div className="form-group mb-0">
                          <label className="login-formlabel text-left mt-2">
                            TOTP
                          </label>
                          <div className="input-group">
                            <input
                              type="text"
                              maxLength={10}
                              className="formcontainer-inputfield mb-3"
                              id="inputTotp"
                              value={totpCode}
                              onChange={(event) => {
                                setTotpCode(event.target.value);
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  onCompleteTotp(e);
                                }
                              }}
                            />
                            <button
                              type="button"
                              className="formfields-button m-auto "
                              onClick={onCompleteTotp}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      )}

                      {showQRCode !== true &&
                        showTotpCode === true &&
                        showRegisterAuth === false && (
                          <div className="form-group">
                            <div className="text-center mt-4 font-weight-light">
                              <button
                                type="button"
                                className="btn p-0 text-primary"
                                onClick={onResetAuthenticator}
                              >
                                reset
                              </button>
                              <span className="txt-sm"> authenticator? </span>
                            </div>
                          </div>
                        )}

                      {((showQRCode !== true &&
                        showTotpCode !== true &&
                        showRegisterAuth === false) ||
                        (showQRCode !== true &&
                          showTotpCode === true &&
                          showRegisterAuth === true)) &&
                        authType === "client" &&
                        shouldShowFederatedButton &&
                        location?.state?.meaUser === undefined &&
                        !enableSupportBtn  && (
                          <>
                            <div className="my-3 d-flex justify-content-center">
                              <button
                                type="button"
                                id="btnFederatedLogin"
                                className="form-icon-button font-weight-medium formfields-button  auth-form-btn authenticate-btn"
                                onClick={handleFedLogin}
                                disabled={
                                  !(
                                    authType === "client" &&
                                    shouldShowFederatedButton &&
                                    !email
                                      .toLowerCase()
                                      .endsWith("@meaplatform.com")
                                  )
                                }
                              >
                                <span> <MdOutlineEmail className="fedaratedEmail-logo"/></span> {federatedButtonLabel}
                              </button>
                            </div>
                          </>
                        )}
                    </form>
                  </div>
                </div>
                <div className="flex-center flex-col">
                  <p className="login-footertitle login-div-footer-title">
                    read mea
                    <a
                      className="login-form-footer-text font-Poppins mr-1 ml-1"
                      href="https://www.meaplatform.com/privacy-policy/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      privacy policies
                    </a>
                    and
                    <a
                      className="login-form-footer-text font-Poppins mr-1 ml-1"
                      href="https://www.meaplatform.com/terms/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      terms and conditions
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        className="modal-mini modal-primary new-modal"
        backdrop="static"
        show={showModal}
        onHide={() => setShowModal(false)}
        animation={false}
        centered={true}
      >
        <Modal.Header className="justify-content-end pt-3">
          <button className="closeicon" onClick={() => setShowModal(false)}>
            <RiCloseLine />
          </button>
        </Modal.Header>
        <Modal.Body className="text-center pt-0 pb-3 px-3">
          <div className="text-center modal-msg">
            <p className="identiy-icons">
              <RiUserUnfollowLine />
            </p>
            {showModalMsg}
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center pb-0">
          <p>
            powered by <span>mea platform</span>
          </p>
        </Modal.Footer>
      </Modal>
      {/* Mini Modal */}
      <Modal
        className="modal-centre new-modal"
        backdrop="static"
        keyboard={false}
        show={isLoading}
        animation={false}
        centered={true}
      >
        <Modal.Body className="text-center">
          <CirclesLoader isLoading={isLoading} />
        </Modal.Body>
      </Modal>
      {/* End Modal */}

      <Modal
        className="modal-md modal-primary"
        show={modalContent.show}
        onHide={() =>
          setModalContent({
            show: false,
            title: "",
            body: "",
            primaryAction: {},
            secondaryAction: null,
          })
        }
        backdrop="static"
        animation={false}
        backdropClassName="question-modal"
      >
        <Modal.Header className="justify-content-center">
          <div className="modal-profile">
            <i className="nc-icon nc-bulb-63"></i>
          </div>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p className="multi-line">{modalContent.title}</p>
        </Modal.Body>
        <div className="modal-footer justify-content-center">
          {modalContent.primaryAction && (
            <button
              type="button"
              className="btn btn-secondary btn-md font-weight-medium yesBtn"
              onClick={() => modalContent.primaryAction.onClick()}
            >
              {modalContent.primaryAction.text}
            </button>
          )}
          {modalContent.secondaryAction && (
            <button
              type="button"
              className="btn btn-primary btn-md font-weight-medium"
              onClick={() => modalContent.secondaryAction.onClick()}
            >
              {modalContent.secondaryAction.text}
            </button>
          )}
        </div>
      </Modal>
    </>
  );
}

export default Start;
